import React from 'react';

import * as S from './BreadCrumbWrap.styles';

const BreadCrumbWrap = () => (
  <S.BreadCrumbWrapDiv>
    <S.BreadCrumbLeftWrapDiv>
      <S.BreadCrumbLeftWrapInnerDiv>
        <S.BackHotelDetailWrapDiv>
          <S.ReviewBookingTextPara>Review your Booking</S.ReviewBookingTextPara>
        </S.BackHotelDetailWrapDiv>
      </S.BreadCrumbLeftWrapInnerDiv>
    </S.BreadCrumbLeftWrapDiv>
  </S.BreadCrumbWrapDiv>
);

export default BreadCrumbWrap;
